module.exports = __webpack_public_path__ + "img/driver-v3-android.1636ff01.png";